import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2","key":"svg-0"}],["path",{"d":"M3 12h13l-3 -3","key":"svg-1"}],["path",{"d":"M13 15l3 -3","key":"svg-2"}]]

const IconLogin2 = createReactComponent('outline', 'login-2', 'Login2', __iconNode);

export default IconLogin2;